import { render } from "./tefila.vue?vue&type=template&id=3e52b773"
import script from "./tefila.vue?vue&type=script&lang=js"
export * from "./tefila.vue?vue&type=script&lang=js"

import "./tefila.vue?vue&type=style&index=0&id=3e52b773&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__